import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import Page from "../views/Page.vue";
import NotFound from "../views/NotFound.vue";
import List from "../views/List.vue";
import Article from "../views/Article.vue";
// import Event from '../views/Event.vue';
import History from "../views/History.vue";
import ContactUs from "../views/ContactUs.vue";
import Report from "../views/Report.vue";
import Proposal from "../views/Proposal.vue";
import Donate from "../views/Donate.vue";
import Media from "../views/Media.vue";
import Search from "../views/Search.vue";

import Header from "../components/Header.vue";
import HeaderWithVideo from "../components/HeaderWithVideo.vue";
import Footer from "../components/Footer.vue";

// import Temp from '../views/temp.vue';

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior: (to, from) => {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      if (
        to.name == "list" &&
        from.name == to.name &&
        from.params.type == to.params.type
      ) {
        return;
      }
      return {
        x: 0,
        y: 0
      };
    }
  },
  base: process.env.BASE_URL,
  routes: [{
      path: "/pdf/*",
      beforeEnter: to => {
        location.href = process.env.VUE_APP_API_URL + to.path;
      }
    },
    // {
    //     path: '/temp',
    //     name: 'temp',
    //     components: {
    //         default: Temp,
    //     }
    // },
    {
      path: "/",
      name: "home",
      components: {
        header: HeaderWithVideo,
        default: Home,
        footer: Footer
      }
    },
    {
      path: "/proposal",
      name: "proposal",
      children: [{
          path: "edit",
          name: "proposal_edit"
        },
        {
          path: "edit/login",
          name: "proposal_login"
        },
        {
          path: "logout",
          name: "proposal_logout"
        }
      ],
      components: {
        header: Header,
        default: Proposal,
        footer: Footer
      }
    },
    {
      path: "/donate",
      name: "donate",
      children: [{
          path: "form/:company([A-Za-z0-9\\-\\_\\s%20]+)?",
          name: "donate_form"
        },
        {
          path: "asiapay",
          name: "donate_asiapay"
        },
        {
          path: "alipay",
          name: "donate_alipay"
        },
        {
          path: "thankyou/:company([A-Za-z0-9\\-\\_\\s%20]+)?",
          name: "donate_thankyou"
        },
        {
          path: "transaction_error/:company([A-Za-z0-9\\-\\_\\s%20]+)?",
          name: "donate_transaction_error"
        }
      ],
      components: {
        header: Header,
        default: Donate,
        footer: Footer
      }
    },
    {
      path: "/search/:type([a-z]+)?/:page([0-9]+)?",
      name: "search",
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: Search,
        footer: Footer
      }
    },
    {
      path: "/404",
      component: NotFound,
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: NotFound,
        footer: Footer
      }
    },
    {
      path: "/(public_upload/)?:type(album|video)",
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: Media,
        footer: Footer
      }
    },
    {
      path: "/:type(events|news|achievement|beneficiaries)/:segment([a-z][a-z\\-\\_\\s%20]*)?/:osc_year([0-9]+)?",
      name: "list",
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: List,
        footer: Footer
      }
    },
    {
      path: "/article/:type(achievement)/:id([0-9]+)?",
      component: Article,
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: Article,
        footer: Footer
      }
    },
    {
      path: "/event/:slug",
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: Page,
        // default: Event,
        footer: Footer
      }
    },
    {
      path: "/history",
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: History,
        footer: Footer
      }
    },
    {
      path: "/contactus",
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: ContactUs,
        footer: Footer
      }
    },
    {
      path: "/report",
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: Report,
        footer: Footer
      }
    },
    {
      path: "(/[a-z\\-\\_\\s%0-9]+)+",
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: Page,
        footer: Footer
      }
    },
    {
      path: "*",
      meta: {
        title: "",
        desc: ""
      },
      components: {
        header: Header,
        default: NotFound,
        footer: Footer
      }
    }
  ]
});